export default __webpack_public_path__ + "static/media/pic24.2bc087cb.jpg";